import React from 'react'
import ReduxLinkDecorator from '../../containers/ReduxLinkDecorator';
import { Translate, I18n } from "react-redux-i18n";

import {
    NonIdealState,
    Button
} from "@blueprintjs/core";

const DashboardNewCircle=()=>{
    return (
        <div>
            <h1 className="sidebar-heading">
                <Translate value="my_circles.circles_near_you"/>
            </h1>
            
                <div className="near-circles">
                    <NonIdealState
                        icon="add"
                        title={I18n.t("new_circle.did_not_find")}
                        description={I18n.t("new_circle.did_not_find_description")}
                        action={
                            <ReduxLinkDecorator goTo="new-circle">
                                <Button intent="primary" fill={false}>
                                    <Translate value="new_circle.create_a_circle" />
                                </Button>
                            </ReduxLinkDecorator>
                        }
                    />
                    <div className="spacer-16" />
                </div>
        </div>
    )
}

export default DashboardNewCircle;